<template>
  <JsonEditorVue />
</template>

<script setup>
import JsonEditorVue from 'json-editor-vue';
</script>